import React, { useEffect, useRef, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import InputDialog from './InputDialog';
import { useSelector } from 'react-redux';
import config from '../../config';
import { DateRangePicker } from 'react-date-range';
import ModalEditRemarks from './ModalEditRemarks';
import ModalLoan from './ModalLoan';
import * as XLSX from 'xlsx';  // Library for handling Excel file parsing
import { Loader } from 'lucide-react';
import { set } from 'date-fns';
import FailedMessage from './FailedMessage';
import SettlementInput from './SettlementInput';


const AgencyForm1 = () => {
    const [data, setData] = useState()
    const[loan, setLoan] = useState('')
    const [loan_data, setloanData] = useState()
    const [percentage, setPercentage] = useState()
        const [currentPage, setCurrentPage] = useState(1)
            const [totalPages , setTotalPages] = useState()
              const [errorMsg, setErrorMsg] = useState("");
               const [showSuccessModal, setShowSuccessModal] = useState(false);
            const [linkData, setLinkData] = useState("");
              const [message, setMessage] = useState()
            
                const [selection , setSelection] = useState()
                const [startDate, setStartDate] = useState('');
                const [endDate, setEndDate] = useState('');
                          const [loadingbutton, setloadingbutton] = useState()
                          const [error, setError] = useState(null);
                           const [loading, setLoading] = useState(false); // Loading state
                             const [settlementData, setSettlementData] = useState('');
                           const [settlementAmount, setSettlementAmount] = useState("");
                     const [settlement, setSettlement] = useState(); // State to control settlement modal visibility  
                           
            
                const [selectedOptions, setSelectedOptions] = useState('')
                const [agency, setAgency] = useState()
                const [showCustomRange, setShowCustomRange] = useState(false);
                const [start,setstart] = useState()
                const [end,setend] = useState()
                const [formData, setFormData] = useState({});
               const current_user = useSelector((state)=> state?.user?.currentUser?._id)
               const user_data = useSelector((state)=> state?.user?.currentUser)
               const [remarks, setRemarks] = useState('');
               const [remarksStatus, setRemarksStatus] = useState(false); 
            let [AgencySelection, setAgencySelection] = useState('')
                  const [cog_id, setCog_id] = useState()
                
                                          const [showModal, setShowModal] = useState(false); // Controls modal visibility
                                          const [showModal1, setShowModal1] = useState(false); // Controls modal visibility
              const [loan_no, setLoan_no] = useState('')
            
                                          const [selectedLoanId, setSelectedLoanId] = useState(null); // Stores the selected loan_id
            
        const [selectedOption, setSelectedOption] = useState('');
        
    
    const individual = useSelector((state)=>  state.Individual.individual_role)

    const serviceSelect = useRef(null);
    const dailySelect = useRef(null);
    const [openDate, setOpenDate] = useState(false)
    const [waiverCheckData, setWaiverCheckData] = useState(null);
    const [showWaiverInfoModal, setShowWaiverInfoModal] = useState(false);
    
      const [selectionRange, setSelectionRange] = useState({
        startDate: '',
        endDate: '',
        key: "selection",
      });
        const [showCalendar, setShowCalendar] = useState(false); // State to toggle calendar visibility
          const modalRef = useRef();
      const handleHideMessage = () => setMessage(''); // Clear the message when the alert hides
  
  const handleSettlement = async(e) => {
      setLoading(true)
      e.preventDefault(); // Prevent default form submission

      console.log(settlement,settlementAmount, "====================")
    if (isNaN(Number(settlementAmount)) || Number(settlementAmount) < 2 * Number(settlement?.loan_amt)) {
      setLoading(false)
      setErrorMsg(`Settlement amount must be at least double the loan amount (${2 * Number(settlement?.loan_amt)})`);
    } else {
          let settlements = await fetch(`${config.apiUrlBetaV2}get_waiver/${settlement?.loan_id}?setlement=${settlement?.setlement}&total_amt=${settlementAmount}`,{
      Method: 'GET',
      headers: {
        'Content-Type': 'application/json', // Specify the content
        'Authorization': localStorage.getItem('access_token'),  // Replace with your actual token
    }})
    settlements = await settlements.json()
    if(settlements.ok){
      setErrorMsg(false)
      setLoading(false)
    }
    if(settlements.status == false){
      setErrorMsg(settlements.message)
      setLoading(false)
                setShowSuccessModal(false); // Close the success modal if it's open

    }
    if(settlements.status == true){
          setShowSuccessModal(true); // Close the success modal if it's open
      setLoading(false)

    }
    console.log(settlements, "====================")
    setLinkData(settlements)
      // proceed with logic (API call, etc.)
      alert('Settlement successful');
    }
  };
  const handleWaiverClick = async (loan_id) => {
    const token = localStorage.getItem('access_token');
    try {
      const res = await fetch(`${config.apiUrlBetaV1}check_waiver?loan_id=${loan_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });
      const json = await res.json();
      console.log("check_waiver response:", json);
  
      // Parse the error object — it may come as a JSON string or plain object
      let errorData = null;
      if (json?.error) {
        errorData = typeof json.error === 'string' ? JSON.parse(json.error) : json.error;
      }
  
      // If link was already generated today (payment_genration === true), show info modal
      if (errorData && errorData?.payment_genration === true) {
        setWaiverCheckData(errorData);
        setLoan(String(loan_id));
        setShowWaiverInfoModal(true);
      } else {
        // Normal flow — open the existing waiver modal
        setLoan(String(loan_id));
        setTimeout(() => {
          const modalEl = document.getElementById('exampleModal');
          if (modalEl) {
            const modal = new window.bootstrap.Modal(modalEl);
            modal.show();
          }
        }, 100);
      }
    } catch (err) {
      console.error('Waiver check failed:', err);
      // On error, fallback to normal flow
      setLoan(String(loan_id));
      setTimeout(() => {
        const modalEl = document.getElementById('exampleModal');
        if (modalEl) {
          const modal = new window.bootstrap.Modal(modalEl);
          modal.show();
        }
      }, 100);
    }
  };
        const handleShow = (loanId, currentRemarks, currentRemarksStatus) => {
          setSelectedLoanId(loanId);
          setRemarks(currentRemarks);
          setRemarksStatus(currentRemarksStatus);
          setShowModal(true); // Show modal
        };
            const fetchDataForPage = async (page) => {
                         const token = localStorage.getItem('access_token')

                         try {
                           const response = await fetch(`${config.apiUrlBetaV2}mapped_collection/${user_id._id}?${selectedOptions}=${formData.LoanId}&account_type=${formData.accountType}&${selectedOptions}start=${new Date(selectionRange.startDate).toLocaleDateString()}&${selectedOptions}end=${new Date(selectionRange.endDate).toLocaleDateString()}&${selectedOptions}=${AgencySelection}&slab=${selectedOption}&startslab=${start}&endslab=${end}&loanMin=${formData.loanMin}&loanMax=${formData.loanMax}&pages=${page}&excel=true`, {
                             headers: {
                               'Authorization': token,
                               'Content-Type': 'application/json',
                             },
                           });
                     
                           if (!response.ok) {
                             throw new Error('Failed to fetch data');
                           }
                     
                           const data = await response.json();
                   
                           return data;  // Assuming data has the structure { data: [...], totalPages: ... }conso
                         } catch (error) {
                           console.error(error);
                           setError(error.message);
                           return null;
                         }
                       };
                          const spinnerStyle = {
                          border: '4px solid rgba(255, 255, 255, 0.3)',
                          borderTop: '4px solid #3498db',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          animation: 'spin 1s linear infinite',
                          marginRight: '8px', // Space between spinner and text
                        };
                      
                        // Inline styles for the button when loading
                        const loadingTextStyle = {
                          display: 'flex',
                          alignItems: 'center',
                        };
                      
                        // Keyframes for the spinning animation (defined in JS)
                        const styleSheet = document.styleSheets[0];
                        styleSheet.insertRule(`
                          @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                          }
                        `, styleSheet.cssRules.length);
                    
                        // Function to handle exporting all data
                        const handleExport = async () => {
                          setloadingbutton(true);
                          let allData = [];
                          let totalPages = 0;
                      
                          try {
                            // First, get the data from the first page
                            const firstPageData = await fetchDataForPage(1);
                            if (firstPageData) {
                              totalPages = firstPageData.totalPages || 1;
                              allData = firstPageData.data;
                            }
                      
                            // If there are more pages, fetch the remaining pages
                            for (let page = 2; page <= totalPages; page++) {
                              const pageData = await fetchDataForPage(page);
                              if (pageData) {
                                allData = [...allData, ...pageData.data];
                              }
                            }
                            console.log(allData,"===================")
                      
                            // Now generate the Excel file using `xlsx` library
                            const ws = XLSX.utils.json_to_sheet(allData);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, 'Data');
                      
                            // Export the file
                            XLSX.writeFile(wb, 'data.xlsx');
                            setloadingbutton(false)
                          } catch (error) {
                            setError('Error exporting data');
                            setloadingbutton(false)

                          } finally {
                            setLoading(false);
                            setloadingbutton(false)

                          }
                        };
        
        const handleClose = () => setShowModal(false);
    


    const user_id = useSelector((state)=> state.user.currentUser)
    const handleSelectChanges = (event) => {
        const value = event.target.value;

        setSelectedOptions(value);
        if (value === 'Loan Date' || value === 'Due Date') {
          setOpenDate(false);
        } else {
          setOpenDate(true);
        }
      };
      const toggleCalendar = () => {
        setShowCalendar(!showCalendar); // Toggle the calendar visibility
      };
    
  const handleSelects= (ranges) => {

    setSelectionRange(ranges.selection); // Update the selectionRange state with new date range

  };
  const handlAgencySelectChange = (event)=>{

    setAgencySelection(event.target.value)
    fetchData()

  }
  useEffect(() => {
  const modal = document.getElementById("exampleModal");

  const resetModal = () => {
    if (serviceSelect.current) serviceSelect.current.value = "service";
    if (dailySelect.current) dailySelect.current.value = "daily";
  };

  modal.addEventListener("show.bs.modal", resetModal);

  return () => modal.removeEventListener("show.bs.modal", resetModal);
}, []);

  const handleCloseModal2 = () => {

    setShowModal(false); // Close the modal when needed
    setSelectedLoanId(null); // Reset the selected loan ID
  };
  const handleLoanClick1 = (loanId) => {
    setCog_id(loanId); // Capture the clicked loan's id
    setShowModal1(true);        // Show the modal

  };


  const handleCloseModal1 = () => {
    setShowModal1(false); // Close the modal when needed
    setSelectedLoanId(null); // Reset the selected loan ID

  };
  const handleSave = async(loanId, remarks, remarksStatus) => {
    const token = localStorage.getItem('access_token')

    // Perform your save action here...
    const updateResponse = await fetch(`${config.apiUrlBetaV2}update_remark`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        loanId,
        remarks,
        remarksStatus,
        agent_id: user_id._id
      }),
    });
    
  };
  const handleLoanClick = (loan_no,loanId) => {
    console.log(loanId,loan_no,"====================")

    setSelectedLoanId(loanId); // Capture the clicked loan's id
    setLoan_no(loan_no)
    setShowModal(true);        // Show the modal

  };
  const handleCloseModal = () => {
    setstart('')
    setend('')
    setShowCustomRange(false);

  };
  const handleApply = () => {
    setShowCalendar(false); // Close the calendar after applying the date range

  };
  const handleChanges = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value.trim() });
  };
  const handleClick = async(e)=>{
    let value = e.target.value
    setSelection(e.target.value)
    setSelectedOption(e.target.value)
    if (value === 'custom') {
        setShowCustomRange(true); // Show custom range input fields
      } else {
        setShowCustomRange(false); // Hide custom range input fields
      }
  }

 
    async function fetchData(){
      setLoading(true)
      const token = localStorage.getItem('access_token')
          if(AgencySelection == ''){
      AgencySelection = formData.LoanId
    }
        const Respones = await fetch(`${config.apiUrlBetaV2}mapped_collection/${user_id._id}?${selectedOptions}=${formData.LoanId}&account_type=${formData.accountType}&${selectedOptions}start=${new Date(selectionRange.startDate).toLocaleDateString()}&${selectedOptions}end=${new Date(selectionRange.endDate).toLocaleDateString()}&${selectedOptions}=${AgencySelection}&slab=${selectedOption}&startslab=${start}&endslab=${end}&loanMin=${formData.loanMin}&loanMax=${formData.loanMax}&pages=${currentPage}`,{
          method: 'GET',
          headers: {
            'Authorization': token,  // Replace with your actual token
            'Content-Type': 'application/json'  // Include this if you're sending JSON data
          },
        })
        if(Respones.ok)   {   
          setLoading(false)
        }
            const agency = await fetch(`${config.apiUrlBetaV2}agent/${current_user}`,{
              method: 'GET',
              headers: {
                'Authorization': token,  // Replace with your actual token
                'Content-Type': 'application/json'  // Include this if you're sending JSON data
              },
            })
       
               const json_datas = await agency.json()
               setAgency(json_datas.data)
               if(loan != 'undefined' && loan.length > 0){
                const loan_data = await fetch(`${config.apiUrlBetaV2}get_waiver/${loan}?percInterest=${Number(dailySelect.current.value)}&serperInterest=${Number(serviceSelect?.current?.value)}`,{
                  method: 'GET',
                  headers: {
                    'Authorization': token,  // Replace with your actual token
                    'Content-Type': 'application/json'  // Include this if you're sending JSON data
                  },
                })
            const json_data = await loan_data.json()
            console.log(percentage,json_data.data1)

            console.log(json_data)
            setloanData(json_data.data)
            setPercentage(json_data?.data1)
    
    }
        const json_data = await Respones.json()
        setData(json_data.data)
        setTotalPages(json_data.totalPages)

        
    }
    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text)
        .then(() => alert("Copied to clipboard!"))
        .catch(err => console.error("Failed to copy:", err));
    };
    const handlecashfree = (event) =>{
        fetchData()
        const serviceValue = serviceSelect.current.value;
        const dailyValue = dailySelect.current.value;

    }
    const PAGE_LIMIT = 5; // Number of pages to show before and after current page

    const handlePageClick = (page) => {
      setLoading(true)

      if (page < 1 || page > totalPages) return;
      setCurrentPage(page)
      fetchData();
    };
    
    const getPageNumbers = () => {
        const pages = [];
        const leftLimit = Math.max(1, currentPage - Math.floor(PAGE_LIMIT / 2));
        const rightLimit = Math.min(totalPages, currentPage + Math.floor(PAGE_LIMIT / 2));
    
        if (leftLimit > 1) {
            pages.push(1);
            if (leftLimit > 2) pages.push('...'); // Ellipsis for skipped pages
        }
    
        for (let i = leftLimit; i <= rightLimit; i++) {
            pages.push(i);
        }
    
        if (rightLimit < totalPages) {
            if (rightLimit < totalPages - 1) pages.push('...'); 
            pages.push(totalPages);
        }
    
        return pages;
    };
          const isWithin24Hours = (linkDate) => {
    const currentTime = new Date();
    const linkTime = new Date(linkDate);
    const timeDifference = currentTime - linkTime; // Difference in milliseconds
    const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert to hours
    return hoursDifference <= 24;
  };
    const openModal = async (settlementData) => {
      const token = localStorage.getItem('access_token');
      let loan_data = await fetch(`${config.apiUrlBetaV2}get_waiver/${settlementData.loan_id}?percInterest=0&serperInterest=0`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      });

      loan_data = await loan_data.json();
      setSettlementData(loan_data);
      console.log(loan_data, settlementData, "====================");
    
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();
    };
    
   const  handlecashfreelink = async(loan_amount, loan_id, daily_late,service_charge,Payable_amount)=>{
    console.log(loan_amount, loan_id, daily_late,service_charge,Payable_amount,"====================")
    setLoading(true)

    const token = localStorage.getItem('access_token')

    let postData = {
        loan_id: loan_id,
        link_amount: loan_amount,
        daily_late: daily_late,
        service_charge: service_charge,
waived_amount: Number(
  (Number(Payable_amount) - Number(loan_amount)).toFixed(2)
),
    }
    console.log(settlement, "====================")
    console.log(postData, "====================")
    if(settlement?.setlement) postData["settlement"] = true
    const PAGE_LIMIT = 5; // Number of pages to show before and after current page
    const spinnerStyle = {
      border: '4px solid rgba(255, 255, 255, 0.3)',
      borderTop: '4px solid #3498db',
      borderRadius: '50%',
      width: '24px',
      height: '24px',
      animation: 'spin 1s linear infinite',
      marginRight: '8px', // Space between spinner and text
    };
  
    // Inline styles for the button when loading
    const loadingTextStyle = {
      display: 'flex',
      alignItems: 'center',
    };
    
  
    // Keyframes for the spinning animation (defined in JS)
    const styleSheet = document.styleSheets[0];
    styleSheet.insertRule(`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `, styleSheet.cssRules.length);

    const response = await fetch(`${config.apiUrlBetaV2}cashfree_link`, {
        method: 'POST',               // Set the request method to POST
        headers: {
          'Authorization': token,  // Replace with your actual token
          'Content-Type': 'application/json'  // Include this if you're sending JSON data
        },
        body: JSON.stringify(postData) // Convert the data to a JSON string
    });
    if(response.ok){
      setLoading(false)
      setSettlement(null)
    }
    }
    const handleFile = async (e)=>{
      setLoading(true)

      const token = localStorage.getItem('access_token')
        let Respones = await fetch(`${config.apiUrlBetaV2}mapped_collection/${user_id._id}?excel=true`,{
          method: 'GET',
          headers: {
            'Authorization': token,  // Replace with your actual token
            'Content-Type': 'application/json'  // Include this if you're sending JSON data
          },
        })
        if(Respones.ok){
          setLoading(false)
        }
   
        const json_data = await Respones.json()

        const binaryString = window.atob(json_data.body);  
        const byteArray = new Uint8Array(binaryString.length); 
        for (let i = 0; i < binaryString.length; i++) {
          byteArray[i] = binaryString.charCodeAt(i);
        }
    
        const blob = new Blob([byteArray], { type: 'application/octet-stream' }); 
        const url = window.URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.download = 'loan_mapping.xlsx'; 
        link.click();
    
        window.URL.revokeObjectURL(url);



    }

    useEffect(()=>{
        fetchData()
    },[selection,currentPage,totalPages,showCustomRange,selectedOptions,startDate,endDate,selectedOption,AgencySelection,selectionRange,loan])
  return (
    <> 
{loading ? (
            <span style={loadingTextStyle}>
              <div style={spinnerStyle}></div>
            </span>  
    
          ) : (
     <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">

<div className="d-flex flex-wrap gap-4">
  {/* <div className="mb-2">
  </div> */}

  <div className="mb-2">
    <label className="form-label" htmlFor="LoanId">
      Select search
    </label>
    <select
      className="form-select w-auto"
      id="grid-state"
      value={selectedOptions}
      onChange={handleSelectChanges}
    >
      <option value="" disabled>---Select----</option>
      <option value="LoanDate">Loan Date</option>
      <option value="DueDate">Due Date</option>
      <option value="State">State</option>
      <option value="Agency">Agency</option>
      <option value="Mobile_Number">Mobile</option>
      <option value="Loan_Id">Loan Id</option>
    </select>
  </div>

  <div className="mb-2">
    <label className="form-label" htmlFor="LoanId">
      {selectedOptions || "Enter here"}
    </label>

    {selectedOptions === 'LoanDate' || selectedOptions === 'DueDate' ? (
      <>
      

        {openDate && (
    <div style={{ position: "relative", width: "300px" }}>
      <button
        onClick={toggleCalendar}
        style={{
          padding: "7px 6px",
          border: "1px solid #ccc", // Add border to the button
          borderRadius: "5px",
          width: "70%",
          textAlign: "left", // Align text to the left for a cleaner look
          backgroundColor: "#fff",
          cursor: "pointer",
        }}
      >
        {selectionRange.startDate && selectionRange.endDate
          ? `${selectionRange.startDate.toLocaleDateString()} - ${selectionRange.endDate.toLocaleDateString()}`
          : "Select Date Range"
        }
      </button>

      {showCalendar && (
        <div
          style={{
            position: "absolute",
            top: "50px", // Adjust this to position the calendar
            left: "0",
            zIndex: 999,
            backgroundColor: "#fff", // Add a background color to make it more visible
            padding: "10px",
            border: "1px solid #ccc", // Add border for better separation
            borderRadius: "5px",
          }}
        >
          <DateRangePicker
            ranges={[selectionRange]}
            onChange={handleSelects}
            showDateDisplay={false} // Optional: hides date display
          />
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <button
              onClick={handleApply}
              style={{
                padding: "5px 7px",
                border: "1px solid #007BFF",
                borderRadius: "5px",
                backgroundColor: "#007BFF",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>         
        )}
      </>
    ) : selectedOptions === 'Agency' ? (
      <select
        className="form-select w-auto"
        id="AgencyId"
        onChange={handlAgencySelectChange}
        value={AgencySelection}
        
      >
                <option value="" disabled>Select Agency</option>

                {agency?.map((data,index)=>(
                <option key={index} value={data._id}>{data.username}</option>

    ))}
      </select>
    ) : selectedOptions === 'State' ? (
      <select
        className="form-select w-auto"
        id="AgencyId"
        onChange={handlAgencySelectChange}
        value={AgencySelection}
      >
        <option value="" disabled>Select State</option>
        <option value="Andhra Pradesh">Andhra Pradesh</option>
        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
        <option value="Assam">Assam</option>
        <option value="Bihar">Bihar</option>
        <option value="Chhattisgarh">Chhattisgarh</option>
        <option value="Goa">Goa</option>
        <option value="Gujarat">Gujarat</option>
        <option value="Haryana">Haryana</option>
        <option value="Himachal Pradesh">Himachal Pradesh</option>
        <option value="Jharkhand">Jharkhand</option>
        <option value="Karnataka">Karnataka</option>
        <option value="Kerala">Kerala</option>
        <option value="Maharashtra">Maharashtra</option>
        <option value="Madhya Pradesh">Madhya Pradesh</option>
        <option value="Manipur">Manipur</option>
        <option value="Meghalaya">Meghalaya</option>
        <option value="Mizoram">Mizoram</option>
        <option value="Nagaland">Nagaland</option>
        <option value="Odisha">Odisha</option>
        <option value="Punjab">Punjab</option>
        <option value="Rajasthan">Rajasthan</option>
        <option value="Sikkim">Sikkim</option>
        <option value="Tamil Nadu">Tamil Nadu</option>
        <option value="Tripura">Tripura</option>
        <option value="Telangana">Telangana</option>
        <option value="Uttar Pradesh">Uttar Pradesh</option>
        <option value="Uttarakhand">Uttarakhand</option>
        <option value="West Bengal">West Bengal</option>
        <option value="Agency3" disabled>-----UT-----</option>
        <option value="Andaman & Nicobar">Andaman & Nicobar</option>
        <option value="Dadra & Nagar Haveli">Dadra & Nagar Haveli</option>
        <option value="Daman & Diu"> Daman & Diu</option>
        <option value="Jammu & Kashmir">Jammu & Kashmir</option>
        <option value="Ladakh">Ladakh</option>
        <option value="Lakshadweep">Lakshadweep</option>
        <option value="Puducherry">Puducherry</option>
      </select>
    ) : (
      <input
        className="form-control w-auto"
        id="LoanId"
        type="text"
        placeholder="Search here"
        onChange={handleChanges}
      />
    )}

  </div>


  <div className='d-flex flex-wrap gap-2'>
  <button
  onClick={fetchData}
  className="btn btn-primary"
  style={{ height: '50px', width: '120px', marginTop: '30px' }}
>
  Search
</button>
  </div>

</div>



<div className="d-flex flex-wrap align-items-center gap-3">
    
<div className="mb-2">

    {showCustomRange && (
        <div className="modal show" tabIndex="-1" style={{ display: 'block' }} aria-labelledby="customRangeModalLabel">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="customRangeModalLabel">Select Custom Slab Range</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-column gap-2">
                  <div className="mb-1">
                    <label htmlFor="start-date" className="form-label form-label-sm">Start Date</label>
                    <input
                      type="number"
                      id="start-date"
                      value={start}
                      onChange={(e) => setstart(e.target.value)}
                      className="form-control form-control-sm"
                      style={{ width: '45%' }}
                      placeholder="Start"
                    />
                  </div>
                  <div className="mb-1">
                    <label htmlFor="end-date" className="form-label form-label-sm">End Date</label>
                    <input
                      type="number"
                      id="end-date"
                      value={end}
                      onChange={(e) => setend(e.target.value)}
                      className="form-control form-control-sm"
                      style={{ width: '45%' }}
                      placeholder="End"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                <button type="button" className="btn btn-primary" onClick={() => { /* Save custom range logic */ handleCloseModal(); }}>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

  </div>

  {/* <div className="mb-2">
    <label className="form-label" htmlFor="LoanId">
      Min Loan Amount
    </label>
    <input
      className="form-control w-auto"
      id="loanMin"
      type="text"
      placeholder="Min Loan Amount"
      onChange={handleChanges}
    />
  </div>

  <div className="mb-2">
    <label className="form-label" htmlFor="LoanId">
      Max Loan Amount
    </label>
    <input
      className="form-control w-auto"
      id="loanMax"
      type="text"
      placeholder="Max Loan Amount"
      onChange={handleChanges}
    />
  </div>

  <div className="d-flex mt-7 gap-4">
    <button
      onClick={fetchData}
      className="btn btn-primary"
    >
      Search
    </button>
  </div> */}


</div>
<div className="d-flex flex-wrap align-items-center gap-3">
{individual?.loan_details?.export_access === true && (
      <button className="btn btn-sm btn-primary-600" onClick={handleExport}>
              {loadingbutton ? (
              <span style={loadingTextStyle}>
              <div style={spinnerStyle}></div>
              downloading...
            </span>

        ):(   
          <>     
          <i className="ri-add-line" />  
          Download Excel
          </> 
        )}
      </button>
    )}
</div>
</div>
              )}

<div className="card-body">
<div style={{ overflowX: 'auto', maxHeight: '750px', overflowY: 'auto' }}>
<table className="table bordered-table mb-0">
<thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
        <tr>
        <th scope="col">LoanDate</th>
                <th scope="col">Last Login</th>

        <th scope="col">Loan Id</th>

            <th scope="col">Agent Name            </th>
            <th scope="col">Name</th>
            <th scope="col">Account Type</th>
            <th scope="col">Mobile Number</th>

            <th scope="col">Loan Amount</th>
            <th scope="col">College Name</th>
            <th scope="col">Close Count(loan)</th>

            <th scope="col">Past Due day</th>
            <th scope="col">Total Service charge</th>
            <th scope="col">Total Daily Late Fee</th>
            <th scope="col">Total Penalty charges</th>
               <th scope="col">Total  Amount</th>

                <th scope="col">Total Payable Amount</th>
                <th scope="col">Partial Paid Amount</th>

                <th scope="col">Last Paid Date</th>
                  <th scope="col">Amount due</th>
            <th scope="col">Due Date</th>
            <th scope="col">State code</th>
            <th scope="col">Pan Card</th>

            <th scope="col">Offer(20%)</th>
            <th scope="col">Offer(40%)</th>
            <th scope="col">Offer(50%)</th>
            <th scope="col">Offer(60%)</th>
            <th scope="col">Offer(70%)</th>

            <th scope="col">Offer(90%)</th>

            <th scope="col">Address</th>
            <th scope="col">Payment Link</th>

<th style={{ textAlign: 'center' }}>Offers</th>


            <th scope="col">Action</th>
        </tr>
    </thead>
    <tbody>
    {data?.map((data,index)=>{

const linkDate = new Date(data.link_date);  // Replace with the correct field
const currentDate = new Date();
const isLessThan24Hours = (currentDate - linkDate) < (24 * 60 * 60 * 1000);  // Less than 24 hours

// Apply light blue color if the condition is met
const rowClass = isLessThan24Hours ? 'bg-info' : 'bg-info';  // 'bg-info' is a light blue background in Bootstrap
return (

  <tr key={index} className={rowClass}> 
<td>{(new Date(data.start).toISOString().split('T')[0])}</td>
<td>{(new Date(data.updatedOn).toISOString().split('T')[0])}</td>

<td>
<Link to="#" className="text-primary-600">
{data.loan_id}
</Link>
</td>
<td>
<Link to="#" className="text-primary-600">
{data.Agent_name}
</Link>
</td>
<td>
{data.student.name}
</td>
<td>
<Link to="#" className="text-primary-600">
{data.user_acc_type}
</Link>
</td>
<td>
<td>
{data.student.mobile}
</td>

</td>
<td>
<div className="d-flex align-items-center">

<h6 className="text-md mb-0 fw-medium flex-grow-1">
    {data.loan_amt}
</h6>
</div>

</td>
<td>
{data.college_name}
</td>
<td>
<div className="d-flex align-items-center">

<h6 className="text-md mb-0 fw-medium flex-grow-1">
    {data.loan_count}
</h6>
</div>

</td>
<td>
<div className="d-flex align-items-center">

<h6 className="text-md mb-0 fw-medium flex-grow-1">
    {data.defaulted}
</h6>
</div>

</td>
<td>{data.serviceChargeFee}</td>
<td>{data.dailyLateFee}</td>
<td>{data.totalPenalty}</td>
<td>{data.totalAmountPayableOg || data.totalAmountPayable}</td>
<td>{data.totalAmountPayable}</td>
<td>{data.partial_total_paid}</td>
<td>
  {data?.last_partial_paid 
    ? new Date(data.last_partial_paid).toISOString().split('T')[0] 
    : 'NA'}
</td>
<td>{data.totalAmountPayable}</td>

<td>{(new Date(data.due).toISOString().split('T')[0])}</td>
<td>{data.state_code}</td>
<td>{data.pan_number}</td>

<td>{data['20%']}</td>
<td>{data['40%']}</td>

<td>{data['50%']}</td>
<td>{data['60%']}</td>
<td>{data['70%']}</td>

<td>{data['90%']}</td>


<td>
{" "}
<span className="bg-success-focus text-success-main px-24 py-4 rounded-pill fw-medium text-sm">
{data.Address}
</span>
</td>
<td >
    <div className="d-flex align-items-center gap-2">
      <h6 className="text-md mb-0 fw-medium flex-grow-1">{data?.payment_link}</h6>
      <button 
        className="btn btn-sm btn-outline-primary"
        onClick={() => copyToClipboard(data?.payment_link)}
      >
        Copy
      </button>
    </div>
  </td>
  
<td

>
  {/* Send Icon */}
  <div className="d-flex align-items-center justify-content-start gap-3 flex-wrap">

       {/* Waiver */}
                <div
     className="d-flex align-items-center gap-1 px-2 py-1 rounded bg-light border border-warning"
     role="button"
     onClick={() => handleWaiverClick(data.loan_id)}
     title="Request Waiver"
     style={{ cursor: 'pointer', transition: '0.2s ease' }}
   >
     <Icon
       icon="cil:paper-plane"
       style={{ fontSize: '20px', cursor: 'pointer' }}
     />
     <i className="bi bi-percent text-warning fs-5" />
     <span className="text-warning fw-medium small">Waiver</span>
   </div>
    {/* Settlement & Waiver */}
    {data.defaulted >= 365 && (
      <>
        {/* Settlement */}
        <div
          className="d-flex align-items-center gap-1 px-2 py-1 rounded bg-light border border-success"
          role="button"
          onClick={() => {
            const newSettlement = {
              loan_id: data.loan_id,
              loan_amt: data.loan_amt,
              student_cog_id: data.student_cog_id,
              setlement: true,
              total_amt: 2 * Number(data.loan_amt),
            };
            setSettlement(newSettlement);
            openModal(newSettlement);
          }}
          title="Open Settlement Modal"
          style={{ cursor: 'pointer', transition: '0.2s ease' }}
        >
          <i className="bi bi-cash-coin text-success fs-5" />
          <span className="text-success fw-medium small">Settlement</span>
        </div>

 
      </>
    )}
  </div>
</td>
<td>
<Link
to="#"
className="w-32-px h-32-px  me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
>
<Icon icon="iconamoon:eye-light"
onClick={() => handleLoanClick1(data.student_cog_id)}

/>
</Link>
<Link
to="#"
className="w-32-px h-32-px  me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
>
<Icon icon="lucide:edit"
onClick={() => handleLoanClick(data?.loan_id, data?._id)}

/>
</Link>

</td>

</tr>
)
})}

      
    </tbody>
</table>

</div>
<div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
            <span>
                Showing {(currentPage - 1) * 10 + 1} to {Math.min(currentPage * 10, totalPages * 10)} of {totalPages * 10} entries
            </span>
            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                {/* Previous Button */}
                <li className="page-item">
                    <Link
                        className={`page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px ${currentPage === 1 ? 'bg-base' : ''}`}
                        to="#"
                        onClick={() => handlePageClick(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </Link>
                </li>

                {/* Page Numbers */}
                {getPageNumbers().map((page, index) => (
                    <li key={index} className="page-item">
                        {/* Render page number or ellipsis */}
                        <Link
                            className={`page-link fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px ${
                                page === currentPage ? 'bg-primary-600 text-white' : 'bg-primary-50 text-secondary-light'
                            }`}
                            to="#"
                            onClick={() => page !== '...' && handlePageClick(page)}
                        >
                            {page}
                        </Link>
                    </li>
                ))}

                {/* Next Button */}
                <li className="page-item">
                    <Link
                        className={`page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px ${currentPage === totalPages ? 'bg-base' : ''}`}
                        to="#"
                        onClick={() => handlePageClick(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </Link>
                </li>
            </ul>
        </div>


</div>
<div
className="modal fade"
id="exampleModal"
tabIndex={-1}
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>
<div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
    <div className="modal-content radius-16 bg-base">
        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
                Generate Link
            </h1>
            <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            />
        </div>
        <div className="modal-body p-24">
            <form action="#">
            <div className="d-flex flex-wrap align-items-center gap-3 mb-5">
            <p className="fw-semibold text-gray-500">Service  %:</p>
  <select
    id="service"
    className="form-select form-select-sm w-auto"
    defaultValue="service"
    ref={serviceSelect}
    onChange={handlecashfree}
  >
    <option value="service" disabled>
      Select Service charge discount
    </option>
    {percentage
      ?.find(item => item?.type === 'service_fee')
      ?.values.map((value, index) => (
        <option key={index} value={value}>
          {value}%
        </option>
      ))}
  </select>


    <p className="fw-semibold text-gray-500">Daily  %:</p>

    <select
  id="daily"
  className="form-select form-select-sm w-auto"
  defaultValue="daily"
  ref={dailySelect}
  onChange={handlecashfree}
>
  <option value="daily" disabled>
    Select Defaulted Loans
  </option>
  {percentage
    ?.find(item => item?.type === 'daily_late')
    ?.values.map((value, index) => (
      <option key={index} value={value}>
        {value}%
      </option>
    ))}
</select>
    </div>
    {!loan_data ? (  <div className="text-center py-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
) : (

                <div className="row">
                <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Defaulting in days:</p>
<p className="text-right text-gray-600">{loan_data?.no_of_days_past_due}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Total Service Charge Fee:</p>
<p className="text-right text-gray-600">{loan_data?.serviceChargeFee}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Loan Amount</p>
<p className="text-right text-gray-600">{loan_data?.loan_amt}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Total Daily Charge Fee:</p>
<p className="text-right text-gray-600">{loan_data?.dailyLateFee}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Total Penalty:</p>
<p className="text-right text-gray-600">{loan_data?.totalPenalty}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Total Amount Payable:</p>
<p className="text-right text-gray-600">{loan_data?.totalAmountPayable}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Service Charge Payable:</p>
<p className="text-right text-gray-600">{loan_data?.service_waived}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Daily Charge Payable:</p>
<p className="text-right text-gray-600">{loan_data?.waived}</p>
</div>
<div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
<p className="fw-semibold text-gray-500">Total Amount to be generated:</p>
<p className="text-right text-gray-600">{loan_data?.waived_total_amount}</p>
</div>

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                        <button
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                       data-bs-dismiss="modal"
                      aria-label="Close"
                      >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                            onClick={()=> handlecashfreelink(loan_data?.waived_total_amount, loan_data.loan_id,loan_data.waived,loan_data?.service_waived, Number(loan_data?.loan_amt) + Number(loan_data?.totalPenalty)

                            )}
                        >
               {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        "Generate"
                      )}
                      {loading && " Loading..."}                          </button>
                    </div>
                </div>
)}
            </form>
        </div>
    </div>
</div>
</div>
<div
  className="modal fade"
  ref={modalRef}
  tabIndex="-1"
  aria-labelledby="settlementModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content p-3">
      <div className="modal-header">
        <h5 className="modal-title" id="settlementModalLabel">
           loan Summary & Settlement
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      {/* <h5 className="modal-title" id="settlementModalLabel">
          Amount must be double of loan amount
        </h5> */}

      <div className="modal-body">
        {/* Required Fields */}
<div className="mb-3 border rounded p-3 bg-light shadow-sm">
  <h6 className="mb-3 text-primary">Loan Summary</h6>
        <div className="row mb-2">
    <div className="col-6"><strong>Name:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.student.name}</div>
  </div>
          <div className="row mb-2">
    <div className="col-6"><strong>mobile:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.student.mobile}</div>
  </div>
          <div className="row mb-2">
    <div className="col-6"><strong>Email:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.student.email}</div>
  </div>

    <div className="row mb-2">
    <div className="col-6"><strong>loan amount:</strong></div>
    <div className="col-6 text-end text-muted">₹{settlementData?.data?.loan_amt}</div>
  </div>
  <div className="row">
    <div className="col-6"><strong>Loan ID:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.loan_id}</div>
  </div>

    <div className="row mb-2">
    <div className="col-6"><strong>Service Charge:</strong></div>
    <div className="col-6 text-end text-muted">₹{settlementData?.data?.serviceChargeFee}</div>
  </div>
  <div className="row mb-2">
    <div className="col-6"><strong>Daily Late Fee:</strong></div>
    <div className="col-6 text-end text-muted">₹{settlementData?.data?.dailyLateFee}</div>
  </div>
  <div className="row mb-2">
    <div className="col-6"><strong>No of DPD:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.no_of_days_past_due}</div>
  </div>
    <div className="row mb-2">
    <div className="col-6"><strong>DLF Slab:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.dailyDefaultFeeSlab}</div>
  </div>
      <div className="row mb-2">
    <div className="col-6"><strong>SF Slab:</strong></div>
    <div className="col-6 text-end text-muted">{settlementData?.data?.service_charge}</div>
  </div>

   <div className="row">
    <div className="col-6"><strong>Total Payable:</strong></div>
    <div className="col-6 text-end text-muted">{Number(settlementData?.data?.loan_amt)+Number(settlementData?.data?.totalPenalty)}</div>
  </div>
</div>
<SettlementInput student_id={settlementData?.data?.student_cog_id}/>
<input
  type="text"
  className="form-control mb-3"
  placeholder="Enter settlement amount"
  value={settlementAmount}
  onChange={(e) => setSettlementAmount(e.target.value)}
/>
   <div>
      <button
        className="btn btn-primary w-100"
        onClick={handleSettlement}
        disabled={loading}
      >
        {loading ? (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
        ) : null}
        {loading ? "Validating..." : "Validate"}
      </button>

      {/* Error message */}
      {errorMsg && (
        <div className="alert alert-danger mt-2" role="alert">
          {errorMsg}
        </div>
      )}
    </div>
      </div>
    </div>
  </div>
</div>
      {showSuccessModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content p-3">
              <div className="modal-header">
                <h5 className="modal-title">Settlement Initiated</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSuccessModal(false)}
                ></button>
              </div>
            
      <div className="modal-body">
        {/* Required Fields */}
<div className="mb-3 border rounded p-3 bg-light shadow-sm">
  <h6 className="mb-3 text-primary"> Settlement Summary</h6>
  <div className="row mb-2">
    <div className="col-6"><strong>Loan Amount:</strong></div>
    <div className="col-6 text-end text-muted">₹{linkData.loan_amount}</div>
  </div>
    <div className="row mb-2">
    <div className="col-6"><strong>Service Charge:</strong></div>
    <div className="col-6 text-end text-muted">₹{linkData.service_charge}</div>
  </div>
  <div className="row mb-2">
    <div className="col-6"><strong>Daily Late Fee:</strong></div>
    <div className="col-6 text-end text-muted">₹{linkData.daily_fee}</div>
  </div>
  <div className="row mb-2">
    <div className="col-6"><strong>Total Amount:</strong></div>
    <div className="col-6 text-end text-muted">₹{linkData.total_amount}</div>
  </div>
  <div className="row">
    <div className="col-6"><strong>Adjust Amount:</strong></div>
    <div className="col-6 text-end text-muted">₹{linkData.monthlyAdjustment}</div>
  </div>
</div>
      <div>
      <button
        className="btn btn-primary w-100"
        disabled={loading}
        onClick={async () => {
          setLoading(true);
          try {
            await handlecashfreelink(
              linkData?.total_amount,
              settlementData.data.loan_id,
              linkData?.daily_fee,
              linkData?.service_charge,
              Number(settlementData?.data?.loan_amt) + Number(settlementData?.data?.totalPenalty)
            );
          } catch (error) {
            console.error("Error generating link:", error);
            // Optional: show error UI here
          } finally {
            setLoading(false);
          }
        }}
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Generating...
          </>
        ) : (
          "Generate Link"
        )}
      </button>
            {message && <FailedMessage message={message} onHide={handleHideMessage} />}

    </div>


   
      </div>
            </div>
          </div>
        </div>
      )}
{showModal && (
    <ModalEditRemarks
    show={showModal}
    handleClose={handleCloseModal2}
    handleSave={handleSave}
    loanId ={loan_no}

    loan_no={selectedLoanId} // Pass the selected loan ID to the modal
  />
      )}

{showModal1 && (
        <ModalLoan
          show={showModal1}
          handleClose={handleCloseModal1}
          CogID={cog_id} // Pass the selected loan ID to the modal
        />
      )}
      {showWaiverInfoModal && (
  <div
    className="modal fade show"
    tabIndex="-1"
    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content p-3">
        <div className="modal-header">
          <h5 className="modal-title text-warning">
            ⚠️ Waiver Link Already Generated Today
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowWaiverInfoModal(false)}
          />
        </div>

        <div className="modal-body">
          <div className="mb-3 border rounded p-3 bg-light shadow-sm">
            <h6 className="mb-3 text-primary">Existing Link Details</h6>

            <div className="row mb-2">
              <div className="col-6"><strong>Generated On:</strong></div>
              <div className="col-6 text-end text-muted">
                {waiverCheckData?.date
                  ? new Date(waiverCheckData.date).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
                  : 'NA'}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6"><strong>Total Payable:</strong></div>
              <div className="col-6 text-end text-muted">
                ₹{waiverCheckData?.totalAmountPayable ?? 'NA'}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6"><strong>Waived Amount:</strong></div>
              <div className="col-6 text-end text-muted">
                ₹{(waiverCheckData?.waivedAmount).toFixed(2) ?? 'NA'}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6"><strong>Service Charge Fee:</strong></div>
              <div className="col-6 text-end text-muted">
                ₹{waiverCheckData?.service_charge_fee ?? 'NA'}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6"><strong>Daily Late Fee:</strong></div>
              <div className="col-6 text-end text-muted">
                ₹{waiverCheckData?.daily_late_fee ?? 'NA'}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6"><strong>Payment Link:</strong></div>
              <div className="col-6 text-end">
                
                 <a href={waiverCheckData?.link_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary text-break small"
                >
                  {waiverCheckData?.link_url ?? 'NA'}
                </a>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-12 text-center">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => copyToClipboard(waiverCheckData?.link_url)}
                >
                  📋 Copy Link
                </button>
              </div>
            </div>
          </div>

          <button
            className="btn btn-warning w-100 mt-2"
            onClick={() => {
              setShowWaiverInfoModal(false);
              setTimeout(() => {
                const modalEl = document.getElementById('exampleModal');
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();
              }, 300);
            }}
          >
            🔁 Generate Again with Different Offer
          </button>
        </div>
      </div>
    </div>
    </div>
)}
    </>  
    
)
}

export default AgencyForm1